<template>
  <div id="app">
    <!--主题色-->
    <link rel="stylesheet" type="text/css" :href="root+'/Public/style.css'"/>
    <div v-wechat-title="$route.meta.title" ></div>
    <keep-alive>
      <router-view :config-data="config" :user-config="userConfig" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view :config-data="config" :user-config="userConfig" v-if="!$route.meta.keepAlive"></router-view>
    <!--<loading></loading>-->
    <to-top></to-top>

  </div>
</template>

<script>
//  import User from '@/pages/user/index'
  import Loading from '@/components/loading'
  import ToTop from '@/components/totop'
  import store from './vuex/store'
  import Bus from '../static/js/bus.js'
  import Vue from 'vue'
  import { Dialog } from 'vant';
  Vue.use(Dialog);
  export default {
    name: 'App',
    components: {
      Loading,
      ToTop
    },
    store,
    data () {
      return {
        config:'',
        userConfig:'',
        root : process.env.API_ROOT,
        notice:''
      }
    },
    methods: {
      getconfig: function () {
        this.$api.get('WebApi/Commom/Index/index', null, res => {
          if( res.data.errCode == '0000' ){
            Bus.$emit('notice', res.data.data.notice)
            this.config = res.data.data;
            localStorage.setItem("BLHlogintype",this.config.logintype);
//            document.title = "博思积分商城";
            //微信登录
            if(this.config.logintype == 1){
              var type=this.$route.query.weixin_type;
//              var usertoken1='14f3b679a9fbfe58937fdf1d92d0052d'//测试
//              localStorage.setItem("BLHuser",usertoken1)//测试
              var usertoken = this.$route.query.token;//正式
              var infoid = this.$route.query.wechat_info_id;
              var readid = this.$route.query.id||'';
              localStorage.setItem("BLHwechat_info_id",infoid);
              localStorage.setItem("read_id",readid);
              if(type==2){
                //未认证登录
                if(readid == ""){
                  //直接进去后走这里
                  this.$router.push({ name: 'Home' })
                  document.body.removeChild(document.getElementById('Loading'))
                }else{
                  this.$router.push({ name: 'Login' })
                  document.body.removeChild(document.getElementById('Loading'))
                }

                document.body.removeChild(document.getElementById('Loading'))

              }else{
                if(usertoken != undefined){
                  usertoken = usertoken.replace(/ /g,"+");
                  localStorage.setItem("BLHuser",usertoken)
                }
                //认证后查询用户信息
                this.getUser()
              }
            }
            //注册登录
            else if(this.config.logintype == 3){
              this.getUser()
            }
          }else if( res.data.errCode == '5000' ){
            document.write("<img src='/static/images/maintainimg.jpg' width='100%'>")
          }
        })
      },
//      获取个人信息
      getUser:function () {
        console.log(12122, this.$route.name)
        var isUser = localStorage.getItem("BLHuser")
        var root = process.env.API_ROOT
        this.$api.post('WebApi/Member/Info/index', {token:isUser}, res => {
          //微信登录查询用户信息
          if(this.config.logintype == 1){
            if(res.data.errCode == '0000'){
              this.userConfig = res.data.data.memberinfo;
              this.$store.commit('userinfo')
              if(
                !this.userConfig.mobile && 
                this.$route.name != 'BindMobile' &&
                this.$route.name != 'Login' &&
                this.$route.name != 'NoteLogin' && 
                this.$route.name != 'BackPass' &&
                this.$route.name != 'Home'
              ) {
                Dialog.alert({
                  title: '提示 ',
                  message: '请先绑定手机号'
                }).then(() => {
                  this.$router.push({ name: 'BindMobile' })
                })
                return
              }
              if(this.userConfig.reset_password == 0 && 
              this.$route.name != 'BindMobile' &&
              this.$route.name != 'Password' &&
                this.$route.name != 'Login' &&
                this.$route.name != 'NoteLogin' && 
                this.$route.name != 'BackPass' && 
                this.$route.name != 'Home'
            ) {
                Dialog.alert({
                  title: '提示 ',
                  message: '为了保障您的账户安全，首次登录时，您需要进行密码重置操作。'
                }).then(() => {
                  this.$router.push({ name: 'Password' })
                })
              }
              this.getRead();
            }else if(res.data.errCode == '0002'){
              Dialog.alert({
                title: '提示 ',
                message: '用户已停用，请联系管理员！'
              }).then(() => {
                WeixinJSBridge.call('closeWindow');
              })
            }else{
              // this.$router.push({ name: 'Login' })
              document.body.removeChild(document.getElementById('Loading'))
              // window.location.href = root + '/WebApi/Index/Index/weixinlogin?redirect=' + window.location.href;
            }
          }
          //注册登录查询用户信息
          else if (this.config.logintype == 3) {
            var usertoken1='14f3b679a9fbfe58937fdf1d92d0052d'
            this.$api.get('WebApi/Commom/Index/index', null, res => {
              if( res.data.errCode == '0000' ){
                this.$store.commit('userinfo')
                document.body.removeChild(document.getElementById('Loading'))
                localStorage.setItem("BLHuser",usertoken1)
                localStorage.setItem("BLHwechat_info_id","3");
                Bus.$emit('notice', res.data.data.notice)
              }
            })
          }
        })
      },
      //验证文章是否已读
      getRead:function () {
        var root = process.env.API_ROOT
        var readid = localStorage.getItem("read_id")||''
        var isUser = localStorage.getItem("BLHuser")
        if(readid!=''){
          this.$api.post('WebApi/Artice/Index/preview', {token:isUser,id:readid}, res => {
            var point=res.data.data.points;
            var readlist=JSON.stringify(res.data.data.articedata);
            if(res.data.errCode == '5020'){
              this.$router.push({name: 'Readed', params: {readlist:readlist,point:point}})
              document.body.removeChild(document.getElementById('Loading'))
            }else{
              if(res.data.errCode == '0000'){
                this.$router.push({name: 'Read', params: {readlist:readlist,point:point}})
                document.body.removeChild(document.getElementById('Loading'))
              }else{
                if(res.data.errCode == '0303'){
                  document.body.removeChild(document.getElementById('Loading'))
                }
              }
            }
          })
        }else{
          // this.$router.push({ name: 'Home' })
          document.body.removeChild(document.getElementById('Loading'))
          // window.location.href = root + '/WebApi/Index/Index/weixinlogin?readid=' + window.location.href;
        }
      },
      // getWeixinCode() {
      //   let local = window.location.href;
      //   window.location.href = 
      //   'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx5fcaa895a15a9f54&redirect_uri=' 
      //   + encodeURIComponent(local) 
      //   + '&response_type=code&scope=snsapi_base&state=123#wechat_redirect'
      //   this.getUrlCode()
      // },
      // getUrlCode() {
      //   // 截取url中的code方法
      //   var url = location.search;
      //   var theRequest = new Object();
      //   if (url.indexOf("?") != -1) {
      //     var str = url.substr(1);
      //     var strs = str.split("&");
      //     for (var i = 0; i < strs.length; i++) {
      //       theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
      //     }
      //   }
      //   console.log(theRequest);
      //   return theRequest;
      // },
    },
    mounted () {
      // this.getWeixinCode()
      this.getconfig();
    },
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue